import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent, SpinnerComponent } from '@mzic/mzic-components';

@Component({
  selector: 'lib-intro-step',
  imports: [CommonModule, TranslocoModule, MzicSvgComponent, SpinnerComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './intro-step.component.html',
  styleUrl: './intro-step.component.scss',
})
export class IntroStepComponent {
  @Input() alias = ''; // User's alias from collection
  @Input() partnerName = 'Nas Nuvens'; // Partner display name
  @Input() partnerIconUrl: string | null = null; // Partner icon URL
  @Input() integrationEnabled = false;
  @Input() integrationEntityName = '';
  @Input() loading = false;
  @Output() continue = new EventEmitter<void>();

  onContinue(): void {
    if (this.loading) {
      return;
    }
    this.continue.emit();
  }

  get displayName(): string {
    return this.alias || 'User';
  }

  get mainTitleKey(): string {
    return this.integrationEnabled
      ? 'lang.main_title_integration'
      : 'lang.main_title';
  }

  get mainDescriptionKey(): string {
    return this.integrationEnabled
      ? 'lang.main_description_integration'
      : 'lang.main_description';
  }

  get infoCard1TextKey(): string {
    return this.integrationEnabled
      ? 'lang.info_card_1_text_integration'
      : 'lang.info_card_1_text';
  }
}
